export default __webpack_public_path__ + "static/media/1464.f5b200ba.png";